export function safeArrayAccess<A>(a: Array<A>, index: number): A | undefined {
  return a[index]
}

export const intersperse = <T>(separator: T, vs: T[]): T[] =>
  vs.flatMap((v, i) => (i === vs.length - 1 ? [v] : [v, separator]))
